import React, { Component } from "react";
import { connect } from "react-redux";
import { translate, Trans } from "react-i18next";

import { activateCpe, statusCpe } from "actions/activations";
//import { activateCpe } from "actions/activationsDummy"; // Import this one for fake calls (do NOT commit it!)

import UserHardware from "containers/UserHardware";

import Wrapper from "components/Wrapper";
import Title from "components/Title";
import Button from "components/Button";
import Loader, { LoaderStyle } from "components/Loader";

import style from "./style.css";

@translate()
@connect((state) => ({
  weCareID: state.session.weCareID,
  sessionHw: state.session.userMaterials,
  userHardware: state.activations.user,
  isLoading: state.activations.user.loading,
  wsError: state.activations.user.error,
}))
export default class PageActivations extends Component {
  state = {
    error: undefined,
    wsResult: undefined,
    retryError: null,
    userHardware: { cpe: [] },
    checkStatusIntervalId: null,
    loaderMessage: null
  };

  disableSubmitButton = false;

  activateMock = false; // Set to true avoid empty "session" when reloading the page in dev mode (do NOT commit it!)
  mockedUserHardware = {
    cpe: [
      {
        cpeMacAddress: "48:4E:FC:94:A5:D0",
        cpeSerial: "500000000950",
        cpeStatus: "Pending activation",
        cpeSupplier: "ZC4455V-ORB",
        location: "TV room",
        smartCardSerial: "3302003720"
      },
      {
        cpeMacAddress: "48:4E:FC:94:A5:D1",
        cpeSerial: "500000000951",
        cpeStatus: "Pending activation",
        cpeSupplier: "ZC4455V-ORB",
        location: "Living room",
        smartCardSerial: "3302003721"
      },
      {
        cpeMacAddress: "48:4E:FC:94:A5:D2",
        cpeSerial: "500000000952",
        cpeStatus: "Pending activation",
        cpeSupplier: "ZC4455V-ORB",
        location: "Bedroom",
        smartCardSerial: "3302003722"
      }
    ]
  };

  constructor(data) {
    super(data);

    let userHardware = undefined;

    if (this.activateMock === true) {
      userHardware = this.mockedUserHardware;
    } else {
      userHardware = this.props.userHardware.data;
    }

    if (typeof userHardware === "undefined") {
      userHardware = this.props.sessionHw;
    }

    this.submitButtonComp = new React.createRef();

    if (typeof userHardware === "undefined") {
      userHardware = {
        interval_status: 10,
        cpe: []
      };
      this.disableSubmitButton = true;
    } else {
      this.disableSubmitButton = false;
    }

    for (let i = 0; i < userHardware.cpe.length; i++) {
      if (userHardware.cpe[i].location === "") {
        this.disableSubmitButton = true;
        break;
      }
    }

    this.state.userHardware = userHardware;
  }

  handleChange(event) {
    let disableSubmitButton = false;
    let userHardware = this.state.userHardware;

    if (typeof event.target.name !== "undefined" && event.target.name !== "" && typeof event.target.value !== "undefined") {
      for (let i = 0; i < userHardware.cpe.length; i++) {
        if (userHardware.cpe[i].cpeSerial === event.target.name) {
          userHardware.cpe[i].location = event.target.value;
        }

        if (!disableSubmitButton && userHardware.cpe[i].location === "") {
          disableSubmitButton = true;
        }
      }
    }

    this.setState(userHardware);

    if (disableSubmitButton) {
      this.submitButtonComp.current.setDisabled();
    } else {
      this.submitButtonComp.current.setEnabled();
    }
  }

  checkStatusLoop(event) {
    let userHardware = this.state.userHardware;
    // Check Status
    this.props.dispatch(statusCpe(this.props.weCareID, userHardware.cpe)).then((response) => {
      this.checkStatusHydrateResponse(response);
      // Installation completed
      if (true === response.result.completed) {
        clearInterval(this.state.checkStatusIntervalId);
        this.setState({
          loaderMessage: null,
          wsResult: true,
          checkStatusIntervalId: null
        });
      // Error during installation
      } else if (typeof response.result.failed === 'boolean' && true === response.result.failed) {
        clearInterval(this.state.checkStatusIntervalId);
        this.setState({
          loaderMessage: null,
          wsResult: false,
          error: null,
          retryError: true,
          checkStatusIntervalId: null
        });
      } else {
        if ('string' === typeof response.result.progress_message) {
          this.setState({loaderMessage: response.result.progress_message});
        }
      }
    });
  }

  checkStatusHydrateResponse(response) {
    let userHardware = this.state.userHardware;
    if (response && response.result && response.result.cpe) {
      cpeLoop:
        for (let i = 0; i < response.result.cpe.length; i++) {
          let cpeData = response.result.cpe[i];

          for (let j = 0; j < userHardware.cpe.length; j++) {
            let hardware = userHardware.cpe[j];

            if (hardware.cpeSerial === cpeData.cpeSerial) {
              hardware.cpeStatus = cpeData.cpeStatus;
              continue cpeLoop;
            }
          }
        }

      this.setState(userHardware);
    }
  }

  launchActivation(weCareID, components) {
    this.props.dispatch(activateCpe(weCareID, components));
  }

  onSubmitForm(event) {
    if (!this.props.isLoading) {
      const { t } = this.props;
      let userHardware = this.state.userHardware;
      let timeoutInterval = 10000;
      if (typeof userHardware.interval_status === 'number') {
        timeoutInterval = userHardware.interval_status * 1000;
      }

      for (let i = 0; i < userHardware.cpe.length; i++) {
        if (userHardware.cpe[i].location === "") {
          this.setState({
            error: t("_ACTIVATIONS_INDEX_ERROR_MISSING_DEVICE_LOCATION"),
          });
          return;
        }
      }

      // Reset error on WS hit
      this.setState({ error: undefined, wsResult: undefined });

      // Check Status
      this.props.dispatch(statusCpe(this.props.weCareID, userHardware.cpe)).then((response) => {
        if (true !== response.result.completed) {
          this.launchActivation(this.props.weCareID, userHardware.cpe)

          let intervalId = setInterval(() => {this.checkStatusLoop()}, timeoutInterval);
          this.setState({checkStatusIntervalId: intervalId});
        }
      });
    }
  }

  hasLoader () {
    return null !== this.state.checkStatusIntervalId;
  }

  render() {
    const validationError = this.state.error;
    const wsResult = this.state.wsResult;
    const wsError = this.state.wsError || this.state.retryError;

    return (
      <Wrapper>
        <Title><Trans>_ACTIVATIONS_INDEX_TITLE</Trans></Title>
        <p><Trans>_ACTIVATIONS_INDEX_DESCRIPTION</Trans></p>

        {this.state.userHardware.cpe.map((hardware, index) => {
          return <UserHardware
                   key={index}
                   type={(index === 0 ? "main" : "extra")}
                   status={hardware.cpeStatus}
                   serial={hardware.cpeSerial}
                   location={hardware.location}
                   onChange={this.handleChange.bind(this)} />
        })}

        <Button onClick={this.onSubmitForm.bind(this)} disabled={this.disableSubmitButton} ref={this.submitButtonComp}>
          {this.hasLoader() && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
          {!this.hasLoader() && <Trans>_ACTIVATIONS_INDEX_CONFIRM_BUTTON</Trans>}
        </Button>

        {validationError && <p className={style.errorMessage}>{validationError}</p>}
        {!validationError && wsError && (
          <p className={style.errorMessage}>
            <Trans>_POST_ACTIVATE_CPE_GENERIC_ERROR</Trans>
          </p>
        )}
        {wsResult && !wsError && (
          <p className={style.successMessage}>
            <Trans>_POST_ACTIVATE_CPE_SUCCESS</Trans>
          </p>
        )}
        {this.hasLoader() && this.state.loaderMessage && (
          <p className={style.defaultMessage}>
            <Trans>{this.state.loaderMessage}</Trans>
          </p>
        )}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PageActivations/index.js